<template>
  <section>
    <header class="header-image ken-burn-center light" data-parallax="true"
            data-natural-height="500" data-natural-width="1920" data-bleed="0"
            data-image-src="../media/header1_amerisolar.jpg" data-offset="0">
      <div class="container">
        <h1>AMERISOLAR</h1>
        <h2>MÓDULOS</h2>
      </div>
    </header>
    <main>
      <section class="section-base">
        <div class="container">
          <div class="row row-fit-lg">
            <div class="col-lg-12">
              <p align="justify">
                &nbsp;&nbsp;
                Amerisolar, Worldwide Energy and Manufacturing USA Co., Ltd, é um fabricante
                profissional de módulos solares, com uma experiência de 25 anos em produção e
                controle de qualidade desde 1993.<br><br>

                &nbsp;&nbsp;Com os melhores e mais avançados equipamentos de produção em diferentes
                países, a Amerisolar mostra uma força cada vez mais competitiva nos mercados dos EUA
                e da UE com módulos solares fabricados nos EUA e na China. Atualmente conta com uma
                capacidade de produção de 8 GW.<br><br>

                &nbsp;&nbsp;Com base na cooperação técnica com institutos alemães e americanos, os
                módulos Amerisolar foram certificados pela ETL, TUV, KTL, JET, JPEC, MCS, CEC, CGC,
                CQC, ISO9001, ISO14001, OHSAS18001 e China “Golden Sun”. Os módulos Amerisolar têm
                sido amplamente usados nos EUA, Alemanha, Brasil, Reino Unido, França, Austrália,
                Japão, Itália, Holanda, Canadá, Coreia do Sul, Grécia, Taiwan e muitos outros países
                e regiões.<br><br>

                &nbsp;&nbsp;Amerisolar possui um laboratório de testes avançado trabalhando junto
                com especialistas e engenheiros alemães e americanos.
              </p>
              <img :src="require('Assets/images/photo_amerisolar1.jpg')">
              <img :src="require('Assets/images/photo_amerisolar2.jpg')">
            </div>
          </div>
        </div>
      </section>
      <MarcasParceiras></MarcasParceiras>
      <br><br>
    </main>
  </section>
</template>

<script>
import MarcasParceiras from 'Homepage/common/MarcasParceiras.vue';

export default {
  name: 'Amerisolar',
  components: {
    MarcasParceiras,
  },
};
</script>

<style scoped>
header {
  height: 250px !important;
  background-image: url("../../assets/images/header1_amerisolar.jpg");
}
header .container {
  padding-top: 50px !important;
}
header h2 {
  color: #0098da !important;
  line-height: 37px;
  text-transform: uppercase !important;
  font-weight: 700 !important;
  margin: 0 !important;
  font-size: 14px !important;
}
</style>
